<template>
  <base-popup
    class="payouts-registry-edit-popup payouts-registry-edit-popup--delete"
    ref="popup"
    :without-icon="true"
  >
    <template #content>
      <div class="payouts-registry-edit-popup__title">
        {{ $t('payouts.by-registry.popup.edit.title') }}
      </div>
      <div class="payouts-registry-edit-popup__fields">
        <text-input
          v-model:value="payoutsRegistry.name"
          :title="$t('payouts.by-registry.popup.edit.fields.name')"
          @enter="handleSave"
        ></text-input>
      </div>
    </template>
    <template #actions>
      <div class="payouts-registry-edit-popup__actions">
        <primary-button
          class="payouts-registry-edit-popup__actions-item"
          @click="handleSave"
          :disabled="v$.$silentErrors.length > 0"
          :label="$t('payouts.by-registry.popup.edit.actions.save')"
        ></primary-button>
      </div>
    </template>
  </base-popup>
</template>

<script>
import BasePopup from '@vue-app/components/base/popup/BasePopup.vue'
import PrimaryButton from '@vue-app/components/base/button/PrimaryButton.vue'
import NoBgButton from '@vue-app/components/base/button/NoBgButton.vue'
import TextInput from '@vue-app/components/base/input/TextInput.vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

export default {
  name: 'PayoutsRegistryEditPopup',
  components: { TextInput, NoBgButton, PrimaryButton, BasePopup },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      payoutsRegistry: {},
    }
  },
  validations() {
    return {
      payoutsRegistry: {
        name: { required },
      },
    }
  },
  methods: {
    open(payoutsRegistry) {
      this.payoutsRegistry = { ...payoutsRegistry }
      return this.$refs.popup.open()
    },
    async handleSave() {
      let isValid = await this.v$.$validate()

      if (!isValid) {
        return false
      }

      this.$refs.popup.confirm(this.payoutsRegistry)
    },
  },
}
</script>

<style lang="scss" scoped>
.payouts-registry-edit-popup {
  :deep(.popup) {
    width: 100%;
    max-width: 465px;

    padding: 46px 87px 70px;
  }

  &__title {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: #666d79;
    margin-bottom: 35px;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-top: 50px;

    &-item {
      padding: 25px;
      margin-bottom: 10px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
